import { render, staticRenderFns } from "./serviceInfo.vue?vue&type=template&id=40d96d98&scoped=true&"
import script from "./serviceInfo.vue?vue&type=script&lang=js&"
export * from "./serviceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d96d98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d96d98')) {
      api.createRecord('40d96d98', component.options)
    } else {
      api.reload('40d96d98', component.options)
    }
    module.hot.accept("./serviceInfo.vue?vue&type=template&id=40d96d98&scoped=true&", function () {
      api.rerender('40d96d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/serviceInfo.vue"
export default component.exports